import { useSupplier } from './supplierContext';
import { AuditLogsList } from '../../../audit-log/components/AuditLogsList';

export const SupplierAuditLogsPage = () => {
  const { supplier } = useSupplier();

  return <AuditLogsList filter={{ supplierId: supplier.id }} />;
};
